/**
 * Logo.js - LeagueMaker stylized wordmark component
 *
 * Variants:
 *   gradient - brand gradient text (default, for light backgrounds)
 *   white    - solid white (for dark/gradient backgrounds)
 *   dark     - solid dark text
 *
 * When REACT_APP_BETA_MODE=true, a small "BETA" badge appears next to the wordmark.
 */

import React from 'react';

const BETA_MODE = process.env.REACT_APP_BETA_MODE === 'true';

function BetaBadge({ variant, size }) {
  const fontSize = `calc(${size} * 0.35)`;
  const borderColor = variant === 'white' ? 'rgba(255,255,255,0.6)' : variant === 'dark' ? '#999' : '#764ba2';
  const color = variant === 'white' ? '#fff' : variant === 'dark' ? '#666' : '#764ba2';
  return (
    <span
      style={{
        fontSize,
        fontWeight: 700,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        border: `1.5px solid ${borderColor}`,
        color,
        borderRadius: 4,
        padding: '1px 5px',
        marginLeft: '0.35em',
        verticalAlign: 'middle',
        lineHeight: 1.4,
        display: 'inline-block',
        // Reset any text fill / background clip from parent gradient
        WebkitTextFillColor: color,
        background: 'none',
        WebkitBackgroundClip: 'unset',
        backgroundClip: 'unset',
      }}
    >
      BETA
    </span>
  );
}

function Logo({ size = '1.4rem', variant = 'gradient' }) {
  const baseStyle = {
    fontWeight: 700,
    fontSize: size,
    letterSpacing: '-0.02em',
    lineHeight: 1,
    display: 'inline-block',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
  };

  if (variant === 'white') {
    return (
      <span style={{ ...baseStyle, color: '#ffffff' }}>
        LeagueMaker{BETA_MODE && <BetaBadge variant="white" size={size} />}
      </span>
    );
  }

  if (variant === 'dark') {
    return (
      <span style={{ ...baseStyle, color: '#333333' }}>
        LeagueMaker{BETA_MODE && <BetaBadge variant="dark" size={size} />}
      </span>
    );
  }

  // gradient variant
  return (
    <span
      style={{
        ...baseStyle,
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text'
      }}
    >
      LeagueMaker{BETA_MODE && <BetaBadge variant="gradient" size={size} />}
    </span>
  );
}

export default Logo;
